import {addModal} from '~/stores/modal';
export function useProfileFollowing(id:string|number){
 const client=useUser(),busy=ref(false),failure=ref('');
 const request=useFetch('/api/profiles/'+id+'/following',{key:'profile-following:'+id,watch:[()=>client.value?.client_id]});
 async function follow(){
  if(busy.value)return;if(!client.value?.client_id)return navigateTo('/auth/signin');
  busy.value=true;failure.value='';
  try{request.data.value=await $fetch('/api/profiles/follow',{method:'POST',body:{profile_id:id,follow:!request.data.value?.is_following}});}
  catch(error:any){failure.value=error.data?.message||'Не удалось изменить подписку. Попробуйте ещё раз.';}
  finally{busy.value=false;}
 }
 function openList(list:'followers'|'following'){
  addModal({title:list==='followers'?'Подписчики':'Подписки',class:'uo-follow-list-modal',component:defineAsyncComponent(()=>import('~/components/Modals/ProfileFollowList.vue')),componentProps:{profileId:id,list}});
 }
 return {data:request.data,error:request.error,refresh:request.refresh,busy,failure,follow,openList,ready:request};
}
